import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TutorialComponent } from '../tutorial/tutorial.component';
/**
 * The navigation bar component for the application.
 * This component displays the navigation menu at the top of the page.
 */
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  dialogRef!: MatDialogRef<any>;

  /**
   * Creates an instance of `NavbarComponent`.
   */
  constructor(private dialog: MatDialog) { }

  /**
   * Lifecycle hook that is called after the component has been initialized.
   * This is a good place for performing any initial setup or data retrieval.
   */
  ngOnInit(): void { }

  openModal(){
    const url = window.location.href;
    let appUrlFilter = url.substring(url.lastIndexOf('/') + 1);
    console.log(appUrlFilter);

    this.dialogRef = this.dialog.open(TutorialComponent, {
      width: '80%',
      height: '80%',
      panelClass: 'custom-modalbox',
    });
    this.dialogRef.componentInstance.appUrlFilter = appUrlFilter;
  }
}
